export default {
	state: {
		beneficiario: {}
	},
	getters: {
		"beneficiario": state => state.beneficiario
	},
	mutations: {
		setBeneficiario(state, payload) {
			state.beneficiario = payload
		}
	},
	actions: {
		atualizarEstadoBeneficiario({ commit }, payload) {
			commit('setBeneficiario', payload)
		}
	}
};